// src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { PrivateRoute } from "./auth/PrivateRoute";
import Navbar from "./components/Navbar";

import Login from "./pages/Login";
import Home from "./pages/Home";
import Main from "./pages/Main";
import Profile from "./pages/Profile";

import AdminPage from "./pages/AdminPage";
import UserSites from "./pages/UserSites";
import Month from "./pages/Month";
import Register from "./pages/Register";
import Visitor from "./pages/Visitor";


const App: React.FC = () => {
  return (
    <BrowserRouter>
    <AuthProvider>
        {/* <Navbar /> */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/" 
            element={
              <PrivateRoute>
                {/* <Home /> */}
                <Main />
              </PrivateRoute>
            }
          />
          <Route 
            path="/main" 
            element={
              <PrivateRoute>
                <Main />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/sites"
            element={
              <PrivateRoute>
                <UserSites />
              </PrivateRoute>
            }
          />
          <Route
            path="/month"
            element={
              <PrivateRoute>
                <Month />
              </PrivateRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PrivateRoute>
                <Register />
              </PrivateRoute>
            }
          />          
          <Route
            path="/visitor"
            element={
              <PrivateRoute>
                <Visitor />
              </PrivateRoute>
            }
          />

        </Routes>
    </AuthProvider>
      </BrowserRouter>
  );
};

export default App;
